<template>
    <SJMMall>
        <div class="memberCostStandardWrap">
            <div class="container">
                <div class="innerBox">
                    <p class="bigTitle">上海久茂国际物流有限公司</p>
                    <p class="smallTitle">Shanghai Job-Mate international logistics co.,ltd(SJM)</p>
                    <p class="title">收费标准</p>
                    <img class="handingImg" src="@/assets/img/tools/becomeMember/memberCostStandard.jpg">
                </div>
            </div>
        </div>
    </SJMMall>
</template>

<script>
    export default {
        name: 'MemberCostStandard',// 成为会员费用清单
    };
</script>

<style lang="scss" scoped>
    .memberCostStandardWrap {
        position: relative;
        background-color: #f3f3f4;

        .container {
            width: 1245px;
            min-width: 1245px;
            padding: 68px 0;
            margin: 0 auto;
            background-color: white;

            .innerBox {
                position: relative;
                box-sizing: border-box;
                width: 1042px;
                min-height: 500px;
                padding: 67px 19px 180px;
                margin: 0 auto;
                font-size: 16px;
                box-shadow: 0 2px 17px 0 rgba(0, 0, 0, 0.16);

                .bigTitle {
                    font-size: 20px;
                    font-weight: 500;
                    text-align: center;
                    letter-spacing: 11px;
                }

                .smallTitle {
                    padding-bottom: 20px;
                    margin-bottom: 10px;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: center;
                    letter-spacing: 1px;
                    border-bottom: 1px dashed #979797;
                }

                .title {
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                }

                .handingImg {
                    display: block;
                    margin: 0 auto;
                }
            }
        }
    }
</style>
